import React from 'react';
import { useAppSelector } from '../app/hooks';
import SelectDeliveryTime from './SelectDeliveryTime';
import SelectDeliveryAddress from './SelectDeliveryAddress';
import SelectDeliveryLocation from './SelectDeliveryLocation';
import getDeliveryRequiresLocationSelection from '../libs/polygon-ordering/src/selectors/getDeliveryRequiresLocationSelection';
import { InlineAlert } from './InlineAlert';
import combineStyles from '../utils/combineStyles';

interface DeliveryDetailsSelectionProps {
  saleType: SALE_TYPE;
  showOnlyTime?: boolean;
  selectedLocationId: string | null;
  setSelectedLocationId: (id: string) => void;
}

export const DeliveryTimeAndAddressSelection = ({
  saleType,
  showOnlyTime,
  selectedLocationId,
  setSelectedLocationId,
}: DeliveryDetailsSelectionProps) => {
  const deliveryRequiresLocationSelection = useAppSelector(getDeliveryRequiresLocationSelection);
  const inlineAlert = useAppSelector(state => state.inlineAlert);

  return (
    <>
      <SelectDeliveryTime saleType={saleType} />
      {!showOnlyTime && (
        <>
          <SelectDeliveryAddress />
          {inlineAlert.visible && (
            <div style={combineStyles(styles.alertContainer)}>
              <InlineAlert />
            </div>
          )}
          {deliveryRequiresLocationSelection && (
            <SelectDeliveryLocation
              selectedLocationId={selectedLocationId}
              setSelectedLocationId={setSelectedLocationId}
            />
          )}
        </>
      )}
    </>
  );
};

const styles: Styles = {
  alertContainer: {
    paddingTop: 20,
    paddingBottom: 20,
    marginLeft: 16,
    marginRight: 16,
  },
};
